import React,{useState, useEffect, useRef}  from 'react';
import { ReactSketchCanvas } from "react-sketch-canvas";
import { useScreenshot } from 'use-react-screenshot'
import {Header,Container, Button,Grid}  from 'semantic-ui-react'
import {useParams} from 'react-router-dom'
import PaketListe from './PaketListe'
import {useApi} from '@wollo-lib/kpe-context'

const styles = {
    border: "0.0625rem solid #9c9c9c",
    borderRadius: "0.25rem",
  };

const Sign=({ws,msgData})=>
{
    const {apiSelect}=useApi()
    const [image, takeScreenshot] = useScreenshot()
    const svgRef=useRef()
    const {UID:transaktionUID}=useParams()
    const {kunde,pakete,zuschlag}=msgData
    const lastUpdate=useRef(false)
  
    const save= async ()=>
    {
        const svg=await svgRef.current.exportSvg()
        ws.current.send(JSON.stringify({
            __type:'broadcast',
            message: {__type:'signature', signature: svg}
        }   ))
        
    }

    const svgUpdated=async (e)=>
    {
        if(!lastUpdate || (Date.now() - lastUpdate.current) >300 )
        {
            const svg=await svgRef.current.exportSvg()
            ws.current.send(JSON.stringify({
                __type:'broadcast',
                message: {__type:'signature', signature: svg}
            }   ))
            lastUpdate.current=Date.now()
        }
    }

    return(
        
            !pakete ? '' :
            <>
                <PaketListe   kunde={kunde} datum={Date.now()/1000} zuschlag={zuschlag} pakete={pakete}  />
                <ReactSketchCanvas
                    style={styles}
                    width="100%"
                    height="200px"
                    strokeWidth={2}
                    strokeColor="blue"
                    background={image}
                    ref={svgRef}
                    onUpdate={svgUpdated}
                />
                <Grid>
                    <Grid.Column key='1' width={3}>
                        <Button  icon='delete' content='löschen' color='red' onClick={e=>{svgRef.current.clearCanvas()}}/>
                    </Grid.Column>
                
                </Grid>
            </>

    )
}


export default  Sign
